import { Collection } from "../ports.js";
const OWN_CARD_KEY = "own_card";
/** The card as last read; undefined before the first read on this phone. */
export function cachedOwnCard(storage) {
    return storage.get(Collection.ownerSettings, OWN_CARD_KEY);
}
export function keepOwnCard(storage, card) {
    return storage.put(Collection.ownerSettings, OWN_CARD_KEY, card);
}
/** Reads the served card and keeps it; a failure leaves the kept one and goes to the caller. */
export async function refreshOwnCard(api, storage) {
    const card = (await api.ownCard()) ?? null;
    await keepOwnCard(storage, card);
    return card;
}
//# sourceMappingURL=own-card.js.map